<template>
  <v-navigation-drawer class="pt-2" app v-model="drawer">
    <v-list>
      <v-list-tile
        v-for="item in items"
        :key="item.title"
        :to="item.path"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
    export default {
        props: {
            drawerProp: {
                type: Boolean
            },
            items: {
                type: Array
            }
        },

        data() {
            return {
                drawer: this.drawerProp
            };
        },

        watch: {
            drawerProp: {
                handler: function(value) {
                    this.drawer = value;
                }
            },
            immediate: true
        }
    }
</script>

<style scoped>

</style>